export enum Complexity {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export const ComplexitiesList = [Complexity.S, Complexity.M, Complexity.L, Complexity.XL]
